import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { RowInput } from "src/components/forms/RowInput";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";
import formulariosService from "src/services/formulariosService";

const CardFormularioResponse = ({
    actionPhase,
    actionState,
    changeActionState,
    user
}) => {
    const { t } = useTranslation('automation');
    const [formularios, setFormularios] = useState([]);

    useEffect(() => {
        async function fetchFormularios() {
            try {
                const result = await formulariosService.listar(user?.clienteId);
                setFormularios(result.data || []);
            } catch (error) {
                console.error("Erro ao buscar formulários:", error);
            }
        }
        if (user?.clienteId) {
            fetchFormularios();
        }
    }, [user?.clienteId]);

    const formulariosFormatted = formularios.map((f) => ({
        value: f._id,
        label: f.title
    }));

    return (
        <Card className="w-full">
            <CardHeader>
                <LabelFromAction>
                    {actionPhase.name}
                </LabelFromAction>
            </CardHeader>
            <CardContent>
                <div className="flex flex-col gap-4">
                    <RowInput
                        label={t('actionCard.formulario.label', 'Formulário')}
                        info={t('actionCard.formulario.info', 'Filtrar por formulário específico')}
                        input={
                            <MultiSelect
                                options={formulariosFormatted}
                                onValueChange={(e) =>
                                    changeActionState({ name: "formularioIds", value: e })
                                }
                                defaultValue={actionState?.formularioIds}
                                placeholder={t('actionCard.formulario.placeholder', 'Selecionar formulários (opcional)')}
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <AutomationOnlyExecute
                        actionState={actionState}
                        changeActionState={changeActionState}
                    />
                </div>
            </CardContent>
        </Card>
    );
};

export default CardFormularioResponse;
